// extracted by mini-css-extract-plugin
module.exports = {"container":"SessionListFilter_container__3SzAm","search":"SessionListFilter_search__26XBW"};